import React from 'react';
import PropTypes from 'prop-types';
import { Input } from '@spark';
import FieldLabel from '@/features/datasets/components/DataCollection/GenerateDataWithAI/shared/FieldLabel';

export const formatCount = (value) =>
    Number.isFinite(value) ? value.toLocaleString('en-US') : '';

export const parseCount = (text) => {
    const digits = (text || '').replace(/[^0-9]/g, '');
    return digits ? parseInt(digits, 10) : null;
};

/** Inline error under a count input that exceeds its ceiling. */
export const maxRecordsErrorText = (max) => `Maximum allowed records: ${max.toLocaleString('en-US')}`;

/**
 * Comma-formatted integer input for record counts (Figma shows "1,000").
 * `value` is a number or null; `onChange` receives the parsed number or null.
 * `errorText` renders in red directly below the input (and turns it red).
 */
const RecordCountInput = ({
    label,
    required = false,
    help,
    placeholder,
    value,
    onChange,
    danger = false,
    errorText = '',
}) => (
    <div className="gdai-field">
        <FieldLabel text={label} required={required} help={help} truncate />
        <Input
            showLabel={false}
            size="medium"
            inputMode="numeric"
            placeholder={placeholder}
            value={formatCount(value)}
            danger={danger || Boolean(errorText)}
            onChange={(event) => onChange(parseCount(event.target.value))}
        />
        {errorText ? (
            <p className="gdai-field-hint gdai-field-hint--error fs-unmask" role="alert">
                {errorText}
            </p>
        ) : null}
    </div>
);

RecordCountInput.propTypes = {
    label: PropTypes.string.isRequired,
    required: PropTypes.bool,
    help: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    danger: PropTypes.bool,
    errorText: PropTypes.string,
};

export default RecordCountInput;
